import Config from '@/config'

import { afterOnLoad } from '@/utils/event'
import { TRACKING_CONFIGS } from '@/constants/tracking-events'

const findFirstScript = () => {
  return document.getElementsByTagName('script')[0]
}

const initDataLayer = (initData = {}) => {
  window.dataLayer = window.dataLayer ?? []

  window.dataLayer?.push({
    event: 'gtm.js',
    'gtm.start': new Date().getTime(),
  })

  window.dataLayer?.push(initData)
}

const createTagScript = (id) => {
  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtm.js?id=${id}`

  return script
}

const injectScript = (id) => {
  initDataLayer({
    event: TRACKING_CONFIGS.virtual_pageview.event_name,
  })

  const firstScript = findFirstScript()
  const gtmTagScript = createTagScript(id)

  firstScript.parentNode.insertBefore(gtmTagScript, firstScript)
}

const injectNoscript = (id) => {
  const noscript = document.createElement('noscript')
  const iframe = document.createElement('iframe')

  iframe.src = 'https://www.googletagmanager.com/ns.html?id=' + id
  iframe.height = '0'
  iframe.width = '0'
  iframe.style = 'display:none;visibility:hidden'

  noscript.appendChild(iframe)

  document.body.appendChild(noscript)
}

function setup() {
  if (!Config.gtmId) {
    return
  }

  afterOnLoad(() => {
    injectScript(Config.gtmId)
    injectNoscript(Config.gtmId)
  }, 3000)
}

export default {
  install(Vue) {
    if (Config.gtmId) {
      setup()
    }
  },
}
